import { UserRegistration } from './UserRegistration'

export default UserRegistration